import Pagination from '@/components/pagination/index.vue';

// service
import Service from '@/service/index.js';
import PurchaseBusinessService from '../../../purchase-business-service.js';

export default {
  components: {
    Pagination
  },
  data() {
    return {
      total: 0,
      currentPage: 1,
      pageSize: 5,
      tableList: [],
      purchaseSignApproveStatus: [],
      supplyType: [],
      formPath: ''
    };
  },
  created() {
    this.id = this.$route.query.id;
    const obj = {
      SIGN_APPROVE_STATUS: 'purchaseSignApproveStatus',
      USER_TYPE: 'supplyType'
    };
    Object.keys(obj).forEach((key) => {
      Service.getSelectList(key).then(res => {
        if (res && res.code === '0') {
          this[obj[key]] = res.data;
        }
      });
    });
    this.getAuditApplyList();
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.formPath = from.name;
    });
  },
  methods: {
    getAuditApplyList (page) {
      if (page) {
        this.currentPage = page.pageNo;
        this.pageSize = page.pageSize;
      }
      const params = {projectId: this.id, pageSize: this.pageSize, pageNum: this.currentPage};
      PurchaseBusinessService.getAuditApplyList(params).then(res => {
        if (res.code === '0') {
          this.tableList = res.data && res.data.list;
          this.total = this.tableList && this.tableList.length;
        }
      });
    },
    toDetailPage (id, status) {
      this.$router.push({
        path: '/person-center/purchase-business/purchase-project/audit-apply/detail',
        query: {
          id: id,
          status: status,
          formPath: this.formPath
        }
      });
    }
  }
};
